/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useI18n } from "intl/useI18n";
import QuantityInput from "./QuantityInput.vue";
import HorizontalScroller from "../common/HorizontalScroller.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import { zipArray } from "../utils";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./CustomSizeSelector.scss";
import { renderList } from "common/vue/render-list";

export default function CustomSizeSelector({
  sizes = [],
  preset = "custom",
  artworkId = "",
  onChange: onChangeProp,
  ...restProps
}: any) {
  const { n } = useI18n();
  const dtfStore = useDtfStore();

  function isPricingLoading() {
    // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
    return dtfStore.isPricingLoading;
  }

  function variantId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return dtfStore.variantId;
  }

  function getBogoAdjustedPrice() {
    // @ts-expect-error TS(4111): Property 'getBogoAdjustedPrice' comes from an inde... Remove this comment to see the full error message
    return dtfStore.getBogoAdjustedPrice;
  }

  function sizeOptions() {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return zipArray(MAX_PRINT_SIZES_GROUPED[preset], sizes);
  }

  function itemTitle(size: any) {
    if (preset === "full-front") {
      if (size?.sizeRange?.toLowerCase?.() === "newborn") return "Newborn";
      if (size?.category?.toLowerCase?.() === "infant") return "Infant";
    }
    const range = size.sizeRange ? `(${size.sizeRange})` : "";
    return `${size.category} ${range}`;
  }

  function itemSubtitle(size: any) {
    return `${size.width}" x ${size.height}"`;
  }

  function getPrice(size: any) {
    const sizeKey = `${size.width}x${size.height}`;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const bogoPrice = getBogoAdjustedPrice()(artworkId, size.id, sizeKey);
    if (bogoPrice) {
      return n(bogoPrice.discountedTotalPrice, "currency");
    }
    return n(size.unitPrice * size.quantity, "currency");
  }

  function handleQuantityUpdate(index: any, value: any) {
    onChangeProp?.({
      index,
      value
    });
  }

  return (
    <div {...restProps} className={cn("custom-size-selector scope-8ec33e17", restProps?.className)}>
      <HorizontalScroller className="scope-8ec33e17" data-testid="horizontal-scroller">
        {renderList(sizeOptions(), (size, index) => (
          <div
            className={cn("custom-size-selector__item scope-8ec33e17", {
              "custom-size-selector__item--unselected": size.quantity === 0
            })}
            key={index}
          >
            <div className="custom-size-selector__item-title scope-8ec33e17">{itemTitle(size)}</div>
            <div className="custom-size-selector__item-subtitle scope-8ec33e17">
              {itemSubtitle(size)}
            </div>
            <QuantityInput
              className="scope-8ec33e17"
              isCustomSize={true}
              minQuantity={0}
              quantity={size.quantity}
              variantId={variantId()}
              onChange={(value: any) => handleQuantityUpdate(size.index, value.value)}
              data-testid="quantity-input"
            />
            <div
              className={cn("custom-size-selector__item-price scope-8ec33e17", {
                "custom-size-selector__item-price--loading": isPricingLoading(),
                "custom-size-selector__item-price--visible": size.quantity > 0
              })}
            >
              {getPrice(size)}
            </div>
          </div>
        ))}
      </HorizontalScroller>
    </div>
  );
}
